import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { PropertyPhotos } from "../../../../global/types";

import "react-image-gallery/styles/css/image-gallery.css";
import {
  AIBadge,
  CloseIconTextWrapper,
  CloseShareWrapper,
  Dialog,
  GalleryWrapper,
  IndexText,
  ShareIconTextWrapper,
  ShareLink,
  SlideWrapper,
  Wrapper,
} from "./styles";
import { AiOutlineClose } from "react-icons/ai";
import { FiShare2 } from "react-icons/fi";
import ReactImageGallery from "react-image-gallery";
import { useParams } from "react-router-dom";

interface IProps {
  photos: PropertyPhotos[] | undefined;
  startIndex: number;
  onClose: () => void;
}

interface IModal {
  open: () => void;
  close: () => void;
}

interface IParams {
  id: string;
}

const PhotosModal = forwardRef<IModal, IProps>(function PhotosModal(
  { photos = [], startIndex, onClose },
  ref
) {
  const { id } = useParams<IParams>();
  const dialog = useRef<HTMLDialogElement>(null);
  const formattedPhotos = photos.map((photo, index) => ({
    original: photo.url_l,
    thumbnail: photo.url_s,
    originalAlt: `Foto ${index + 1} do imóvel`,
    thumbnailAlt: `Miniatura da foto ${index + 1} do imóvel`,
    generated_by_ai: photo.generated_by_ai,
  }));
  const [currentPhoto, setCurrentPhoto] = useState(startIndex);

  useEffect(() => {
    setCurrentPhoto(startIndex);
  }, [startIndex]);

  useImperativeHandle(ref, () => {
    return {
      open() {
        dialog.current?.showModal();
      },
      close() {
        dialog.current?.close();
      },
    };
  });

  function renderItem(item: any) {
    return (
      <SlideWrapper>
        {(item.generated_by_ai === 1 || item.generated_by_ai === true) && (
          <AIBadge>Gerada por IA</AIBadge>
        )}

        <img
          className="image-gallery-image"
          src={item.original}
          alt={item.originalAlt}
        />
      </SlideWrapper>
    );
  }

  function handleSlide(currentIndex: number) {
    setCurrentPhoto(currentIndex);
  }

  return (
    <Dialog ref={dialog}>
      <Wrapper>
        <CloseShareWrapper>
          <CloseIconTextWrapper onClick={onClose}>
            <AiOutlineClose />
            <p>Fechar</p>
          </CloseIconTextWrapper>
          <ShareLink
            href={`https://api.whatsapp.com/send?text=${window.location.origin}/imovel/${id}/photos`}
            target="_blank"
          >
            <ShareIconTextWrapper>
              <FiShare2 />
              <p>Compartilhar</p>
            </ShareIconTextWrapper>
          </ShareLink>
        </CloseShareWrapper>
        {photos && (
          <GalleryWrapper>
            <ReactImageGallery
              items={formattedPhotos}
              startIndex={startIndex}
              showThumbnails={false}
              showBullets={true}
              showPlayButton={false}
              showFullscreenButton={false}
              onSlide={handleSlide}
              renderItem={renderItem}
            />
          </GalleryWrapper>
        )}
        <IndexText>
          {currentPhoto + 1}/{formattedPhotos.length}
        </IndexText>
      </Wrapper>
    </Dialog>
  );
});

export default PhotosModal;
